import { isDockOnTaskEnabled } from "@/components/composer/dock-on-task-flags";

/** Agents first (train 1b): the team strip on Home, the create sheet, the
 *  pill swap. Read at CALL time so tests stub the env between cases and the
 *  OFF path stays byte-identical. The server half is AGENTS_V1. */
export function isAgentsV1(): boolean {
  return process.env.NEXT_PUBLIC_AGENTS_V1 === "true";
}

export const isDockVisible = (pathname: string | null | undefined) => {
  const path = pathname ?? "";
  // The task section kept its own composer until one-composer-everywhere
  // (spec 2026-09-20, R-F1): with that flag on it is a dock route like every
  // other; off, today's answer byte for byte.
  const inTaskSection =
    (path === "/task" || path.startsWith("/task/")) && !isDockOnTaskEnabled();
  // /home is a dock route in both flag states: the dock hosts the home's box
  // there like everywhere else (spec 2026-09-12 one-composer).
  const isSupportSection = path === "/support";
  // The dev page (/dev/line) draws its own stage.
  const inDev = path.startsWith("/dev/");
  return !inTaskSection && !isSupportSection && !inDev;
};

/** The padding a Main-wrapped surface wears while the dock is on: one level
 *  the Dock publishes on the document root (`--site-dock-pad`, Dock.tsx),
 *  the ball's stage while the ball is up and the box's room otherwise. Only
 *  the Dock knows which (the desktop-shell arm rides useLineOn, the door
 *  rides the store), so no layout decides it from the flag. The fallback is
 *  the shipped `pb-28` byte for byte (7rem): a page painted before the
 *  Dock's effect runs, and every page in a build without the Dock, keeps the
 *  shipped room. Nothing where the dock is hidden. */
export const dockPad = (pathname: string | null | undefined): string =>
  isDockVisible(pathname) ? "pb-[var(--site-dock-pad,7rem)]" : "";
